export default Object.freeze({
  educativo: 126,
  terapiaDeHabla: 127,
  terapiaOcupacional: 128,
  terapidaPsicologica: 129,
  terapiaFisica: 130,
  terapiaOromotora: 672,
  terapiaDisfagia: 662,
  otros: 134,
  ABA: 658,
});
